import { modelComposition } from 'trait/composition'

const descriptor = 'model::equipment::properties'

export default modelComposition(descriptor)
